import { Company } from '../model/company';
import { CostCenterBuilder } from './cost-center-builder';
import { PaymentMethodBuilder } from './payment-method-builder';
import { CompanyDiscounts } from '../model/company-discounts';
export class CompanyBuilder {
    static buildCompany(data) {
        let company = new Company();
        company.id = data.company_id;
        company.name = data.name;
        company.nif = data.nif;
        company.address = data.address;
        company.zip = data.zip;
        company.state = data.state;
        company.city = data.city;
        company.active = data.active;
        company.country = data.country;
        company.date_modified = data.date_modified;
        company.date_register = data.date_register;
        company.monthly_invoice = data.monthly_invoice;
        company.invoice_per_cost_center = data.invoice_per_costcenter;
        company.send_reservation_copy = data.send_reservation_copy;
        company.send_invoice_copy = data.send_invoice_copy;
        company.billing_send_invoice_copy = data.billing_send_invoice_copy;
        company.discounts = data.discounts;
        company.billing_email = data.billing_email;
        company.source = data.source;
        company.monthlyInvoice = data.monthly_invoice;
        company.invoicePerCostCenter = data.invoice_per_costcenter;
        company.sendReservationCopy = data.send_reservation_copy;
        company.sendInvoiceCopy = data.send_invoice_copy;
        company.enableBookingRecords = data.enable_booking_records;
        company.allow_clients_change_cost_center = data.allow_clients_change_cost_center;
        company.blockWashes = data.block_washes === "1" ? true : false;
        company.blockPremium = data.block_premium === "1" ? true : false;
        company.sendAllNotificationToAdmins = data.send_all_notification_to_admins === "1" ? true : false;
        company.billingSendInvoiceCopy = data.billing_send_invoice_copy;
        company.rappelAccount = data.rappel_account;
        company.billingEmail = data.billing_email;
        company.state = data.state;
        company.country = data.country;
        company.block_premium_for_some_users = data.block_premium_for_some_users;
        company.costCenters = data.costcenters ? data.costcenters.map(costCenter => CostCenterBuilder.buildCostCenter(costCenter)) : [];
        company.paymentMethods = data.paymethods ? data.paymethods.map(paymentMethod => PaymentMethodBuilder.buildPaymentMethod(paymentMethod)) : [];
        return company;
    }
    static buildCompanyDiscounts(data) {
        let discounts = new CompanyDiscounts();
        discounts.discount = data.discount;
        discounts.rappel_multiplier = data.rappel_multiplier;
        return discounts;
    }
    static buildCompanyPayload(company) {
        return {
            name: company.name,
            nif: company.nif,
            address: company.address,
            zip: company.zip,
            city: company.city,
            monthly_invoice: company.monthly_invoice,
            allow_clients_change_cost_center: company.allow_clients_change_cost_center,
            invoice_per_costcenter: company.invoicePerCostCenter,
            send_reservation_copy: company.send_reservation_copy,
            send_invoice_copy: company.send_invoice_copy,
            billing_send_invoice_copy: company.billingSendInvoiceCopy,
            enable_booking_records: company.enableBookingRecords,
            billing_email: company.billing_email,
            send_all_notification_to_admins: company.sendAllNotificationToAdmins,
            rappel_account: company.rappelAccount,
            block_washes: company.blockWashes,
            block_premium: company.blockPremium,
            block_premium_for_some_users: company.block_premium_for_some_users
        };
    }
}
//# sourceMappingURL=company-builder.js.map